import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchDelivery} from "../../../../../reduxLib/deliveryLib";

function DeliveriesAd() {
    const dispatch = useDispatch();
    const [deliveryPage,setDeliveryPage]=useState([]);
    const deliveriesL= useSelector((state)=> state.deliveryreducer.deliveryList);
    const state=useSelector((state)=> state.deliveryreducer.state);

    useEffect(() => {
        if (!deliveriesL || deliveriesL.length === 0 ) {

            dispatch(fetchDelivery()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setDeliveryPage(action.payload);

                    console.log("playload ",action.payload);
                    console.log("playload E", deliveryPage);
                }
            });

        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setDeliveryPage(deliveriesL);
        }
    }, [dispatch, state,deliveriesL]);

    return (
        <div id="delivery-content" className="p-8 bg-cream font-print">
            <div id="delivery-stats" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Pending Deliveries</p>
                            <p className="text-2xl font-bold text-gray-800">18</p>
                            <p className="text-orange-600 text-sm mt-1">+3 from yesterday</p>
                        </div>
                        <i className="fa-solid fa-clock text-3xl text-orange-500"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">In Transit</p>
                            <p className="text-2xl font-bold text-gray-800">24</p>
                            <p className="text-blue-600 text-sm mt-1">12 arriving today</p>
                        </div>
                        <i className="fa-solid fa-truck text-3xl text-blue-500"></i>
                    </div>
                </div>

            </div>

            <div id="delivery-filters" className="bg-white rounded-lg shadow p-6 mb-8">
                <div className="flex flex-wrap items-center gap-4">
                    <div className="flex items-center space-x-2">
                        <label className="text-sm font-medium text-gray-700">Status:</label>
                        <select className="border rounded-lg px-3 py-2 text-sm">
                            <option>All Status</option>
                            <option>Pending</option>
                            <option>In Transit</option>
                            <option>Delivered</option>
                            <option>Cancelled</option>
                        </select>
                    </div>

                    <div className="flex items-center space-x-2">
                        <label className="text-sm font-medium text-gray-700">Date Range:</label>
                        <input type="date" className="border rounded-lg px-3 py-2 text-sm"/>
                        <span className="text-gray-400">to</span>
                        <input type="date" className="border rounded-lg px-3 py-2 text-sm"/>
                    </div>

                    <div className="flex-1"></div>

                    <div className="flex items-center space-x-2">
                        <div className="relative">
                            <input type="text" placeholder="Search deliveries..."
                                   className="border rounded-lg pl-10 pr-4 py-2 text-sm w-64"/>
                            <i className="fa-solid fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                        </div>
                        <button
                            className="bg-custom-green text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-opacity-90">
                            <i className="fa-solid fa-filter mr-2"></i>
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            <div id="delivery-table" className="bg-white rounded-lg shadow overflow-hidden mb-8">
                <div className="px-6 py-4 border-b">
                    <h2 className="text-xl font-serif font-bold text-custom-green">Active Deliveries</h2>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Order
                                ID
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Customer</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Driver</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Est.
                                Delivery
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        <tr className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">#1247</div>
                                <div className="text-sm text-gray-500">€89.50</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="text-sm font-medium text-gray-900">John Dimitriou</div>
                                        <div className="text-sm text-gray-500">+30 210 123 4567</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Kifisias 123, Marousi</div>
                                <div className="text-sm text-gray-500">Athens, 15123</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Kostas Delivery</div>
                                <div className="text-sm text-gray-500">+30 693 123 4567</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                    <span
                                        className="inline-flex px-2 py-1 text-xs font-semibold rounded-full status-transit">
                                        In Transit
                                    </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                Dec 15, 2024<br/>
                                <span className="text-gray-500">14:30 - 16:30</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                <button className="text-blue-600 hover:text-blue-900">
                                    <i className="fa-solid fa-eye"></i>
                                </button>
                                <button className="text-custom-green hover:text-opacity-80">
                                    <i className="fa-solid fa-map-marker-alt"></i>
                                </button>
                                <button className="text-gray-600 hover:text-gray-900">
                                    <i className="fa-solid fa-phone"></i>
                                </button>
                            </td>
                        </tr>

                        <tr className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">#1246</div>
                                <div className="text-sm text-gray-500">€125.00</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="text-sm font-medium text-gray-900">Maria Kostas</div>
                                        <div className="text-sm text-gray-500">+30 210 987 6543</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Vouliagmenis 45, Glyfada</div>
                                <div className="text-sm text-gray-500">Athens, 16674</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Athens Express</div>
                                <div className="text-sm text-gray-500">+30 694 567 8901</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                    <span
                                        className="inline-flex px-2 py-1 text-xs font-semibold rounded-full status-pending">
                                        Pending
                                    </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                Dec 16, 2024<br/>
                                <span className="text-gray-500">10:00 - 12:00</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                <button className="text-blue-600 hover:text-blue-900">
                                    <i className="fa-solid fa-eye"></i>
                                </button>
                                <button className="text-custom-green hover:text-opacity-80">
                                    <i className="fa-solid fa-play"></i>
                                </button>
                                <button className="text-gray-600 hover:text-gray-900">
                                    <i className="fa-solid fa-edit"></i>
                                </button>
                            </td>
                        </tr>

                        <tr className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">#1245</div>
                                <div className="text-sm text-gray-500">€67.25</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <img
                                        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg"
                                        alt="Customer" className="w-8 h-8 rounded-full mr-3"/>
                                    <div>
                                        <div className="text-sm font-medium text-gray-900">Nikos Papadopoulos</div>
                                        <div className="text-sm text-gray-500">+30 210 456 7890</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Patision 234, Kypseli</div>
                                <div className="text-sm text-gray-500">Athens, 11253</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">Quick Transport</div>
                                <div className="text-sm text-gray-500">+30 695 234 5678</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                    <span
                                        className="inline-flex px-2 py-1 text-xs font-semibold rounded-full status-delivered">
                                        Delivered
                                    </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                Dec 14, 2024<br/>
                                <span className="text-gray-500">Completed</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium space-x-2">
                                <button className="text-blue-600 hover:text-blue-900">
                                    <i className="fa-solid fa-eye"></i>
                                </button>
                                <button className="text-green-600 hover:text-green-900">
                                    <i className="fa-solid fa-check-circle"></i>
                                </button>
                                <button className="text-gray-600 hover:text-gray-900">
                                    <i className="fa-solid fa-receipt"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="px-6 py-4 border-t bg-gray-50 flex justify-between items-center">
                    <div className="text-sm text-gray-700">
                        Showing 1 to 3 of 47 deliveries
                    </div>
                    <div className="flex space-x-2">
                        <button className="px-3 py-1 border rounded text-sm text-gray-600 hover:bg-gray-100">Previous
                        </button>
                        <button className="px-3 py-1 bg-custom-green text-white rounded text-sm">1</button>
                        <button className="px-3 py-1 border rounded text-sm text-gray-600 hover:bg-gray-100">2</button>
                        <button className="px-3 py-1 border rounded text-sm text-gray-600 hover:bg-gray-100">3</button>
                        <button className="px-3 py-1 border rounded text-sm text-gray-600 hover:bg-gray-100">Next
                        </button>
                    </div>
                </div>
            </div>


        </div>

    );

}

export default DeliveriesAd;